import { url } from "../utils/config";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import * as XLSX from "xlsx";
import ImportModal from "../reusable_components/ImportModal";
import postData from "../custom_functions/postData";
import globalConfigAtom from "../atoms/globalConfigAtom";

function ImportVehicle({ setShowImportModal, setReloadData }) {
    const globalConfig = useRecoilValue(globalConfigAtom);
    const importRowsLimit = Number(globalConfig?.importRowsLimit) || 100;

    const downloadExcel = () => {
        const headers = [
            "vin", "make", "model", "year", "plate", "plate_state_province", "vehicle_number", "trim", "odo_unit", "current_odometer", "color", "engine", "transmission", "drivetrain", "tire_size_front", "tire_size_rear", "fuel_type", "ownership", "in_service_date", "warranty_expiration_date", "acquisition_cost", "location", "group", "notes", "custom_field_1", "custom_field_2", "custom_field_3"
        ];
        const ws = XLSX.utils.aoa_to_sheet([headers]);
        const colWidths = headers.map(() => ({ wch: 20 }));
        ws['!cols'] = colWidths;
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "FleetCustomerCars");
        XLSX.writeFile(wb, "fleet_customer_car_template.xlsx");
    };

    function handleFileUpload(file) {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
                if (jsonData.length === 0) {
                    return toast.error("File is empty", { autoClose: 3000 });
                }
                if (jsonData.length > importRowsLimit) {
                    return toast.error(`File can only have up to ${importRowsLimit} records`, { autoClose: 3000 });
                }
                postData(
                    `${url}/import_fleet_car`,
                    { data: jsonData },
                    (error) => {
                        toast.error(error.response.data.message, { autoClose: 3000 });
                    },
                    (data) => {
                        setReloadData((prev) => !prev);
                        const { insertCount, updateCount, faildCount, errorResult } = data;
                        toast.info(
                            `Import Result\n` +
                            `Record Created : ${insertCount}\n` +
                            `Record Updated : ${updateCount}\n` +
                            `Record Failed  : ${faildCount}`,
                            {
                                autoClose: 4000,
                                style: { whiteSpace: "pre-line" },
                            }
                        );
                        if (errorResult.length > 0) {
                            const ws = XLSX.utils.json_to_sheet(errorResult);
                            const wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, "Failed_Records");
                            XLSX.writeFile(wb, "Import_Errors.xlsx");
                        }
                        setShowImportModal(false);
                    }
                );
            } catch (err) {
                console.error("Error reading Excel file:", err);
            }
        };
        reader.onerror = (err) => {
            console.error("FileReader error:", err);
        };
        reader.readAsArrayBuffer(file);
    }

    return (
        <ImportModal setShowModal={setShowImportModal} importRowsLimit={importRowsLimit} downloadExcel={downloadExcel} handleFileUpload={handleFileUpload} type={"car"} />
    );
}

export default ImportVehicle;
